module.exports = __webpack_public_path__ + "img/DiHS_Video_Icon_Sr_Eingang4.fad74206.jpg";